import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Chart as ChartJS } from 'chart.js';

import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import PrivateRoute from './components/PrivateRoute';
import ApprovalProvider from './components/ApprovalProvider';
import PedidosBadgeProvider from './components/PedidosBadgeProvider';
import ApprovalDecisionPage from './components/ApprovalDecisionPage';
import ApprovalsPage from './components/ApprovalsPage';
import RecoveryPage from './components/RecoveryPage';
import { LockdownBanner } from './components/EmergencyControls';
import LoginForm from './components/LoginForm';
import SalesDashboard from './components/SalesDashboard';
import ClientsPage from './components/ClientsPage';
import ProductsPage from './components/ProductsPage';
import GastosPage from './components/GastosPage';
import ReportsPage from './components/ReportsPage';
import ReportPrintView from './components/ReportPrintView';
import InvoicesPage from './components/InvoicesPage';
import InvoiceBuilder from './components/InvoiceBuilder';
import IngresosPage from './components/IngresosPage';
import ConducesPage from './components/ConducesPage';
import DespachosPage from './components/DespachosPage';
import ConduceBuilder from './components/ConduceBuilder';
import ConducePrintView from './components/ConducePrintView';
import CommitmentPrintView from './components/CommitmentPrintView';
import ClientDealPrintView from './components/ClientDealPrintView';
import InvoicePrintView from './components/InvoicePrintView';
import QuotesPage from './components/QuotesPage';
import QuoteBuilder from './components/QuoteBuilder';
import QuotePrintView from './components/QuotePrintView';
import AdminDashboard from './components/AdminDashboard';
import ChangePasswordPage from './components/ChangePasswordPage';
import WhatsAppInboxPage from './components/WhatsAppInboxPage';

ChartJS.defaults.color = '#9DB3C2';
ChartJS.defaults.borderColor = 'rgba(234,242,245,0.10)';
ChartJS.defaults.font.family = "'IBM Plex Sans', sans-serif";

function AppRoutes() {
  const { isLoggedIn, mustChangePassword } = useAuth();
  const location = useLocation();

  // Until they choose their own password, nothing else is reachable.
  if (isLoggedIn && mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route path="/aprobacion/:token" element={<ApprovalDecisionPage />} />
      <Route path="/recuperar" element={<RecoveryPage />} />

      <Route path="/dashboard" element={<PrivateRoute><SalesDashboard /></PrivateRoute>} />
      <Route path="/clients" element={<PrivateRoute><ClientsPage /></PrivateRoute>} />
      <Route path="/products" element={<PrivateRoute><ProductsPage /></PrivateRoute>} />
      <Route path="/expenses" element={<PrivateRoute allowedRoles={['admin']}><GastosPage /></PrivateRoute>} />
      <Route path="/expenses/compromisos/:id/print" element={<PrivateRoute allowedRoles={['admin']}><CommitmentPrintView /></PrivateRoute>} />
      <Route path="/quotes" element={<PrivateRoute><QuotesPage /></PrivateRoute>} />
      <Route path="/quotes/new" element={<PrivateRoute><QuoteBuilder /></PrivateRoute>} />
      <Route path="/quotes/:id/edit" element={<PrivateRoute><QuoteBuilder /></PrivateRoute>} />
      <Route path="/quotes/:id/print" element={<PrivateRoute><QuotePrintView /></PrivateRoute>} />
      <Route path="/conduces" element={<PrivateRoute><ConducesPage /></PrivateRoute>} />
      <Route path="/despachos" element={<PrivateRoute allowedRoles={['admin']}><DespachosPage /></PrivateRoute>} />
      <Route path="/conduces/new" element={<PrivateRoute><ConduceBuilder /></PrivateRoute>} />
      <Route path="/conduces/:id/edit" element={<PrivateRoute><ConduceBuilder /></PrivateRoute>} />
      <Route path="/conduces/:id/print" element={<PrivateRoute><ConducePrintView /></PrivateRoute>} />
      <Route path="/conduces/acuerdos/:id/print" element={<PrivateRoute allowedRoles={['admin']}><ClientDealPrintView /></PrivateRoute>} />
      <Route path="/invoices" element={<PrivateRoute><InvoicesPage /></PrivateRoute>} />
      <Route path="/invoices/new" element={<PrivateRoute><InvoiceBuilder /></PrivateRoute>} />
      <Route path="/invoices/:id/edit" element={<PrivateRoute><InvoiceBuilder /></PrivateRoute>} />
      <Route path="/invoices/:id/print" element={<PrivateRoute><InvoicePrintView /></PrivateRoute>} />
      <Route path="/invoices/:id/preview" element={<PrivateRoute><InvoicePrintView preview /></PrivateRoute>} />
      <Route path="/ingresos" element={<PrivateRoute><IngresosPage /></PrivateRoute>} />
      <Route path="/aprobaciones" element={<PrivateRoute><ApprovalsPage /></PrivateRoute>} />
      <Route path="/whatsapp" element={<PrivateRoute><WhatsAppInboxPage /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
      <Route path="/reports/print" element={<PrivateRoute><ReportPrintView /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute allowedRoles={['admin']}><AdminDashboard /></PrivateRoute>} />
      <Route path="/change-password" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />

      <Route path="*" element={<Navigate to={isLoggedIn ? '/dashboard' : '/login'} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ApprovalProvider>
            <PedidosBadgeProvider>
              <Header />
              <LockdownBanner />
              <AppRoutes />
            </PedidosBadgeProvider>
          </ApprovalProvider>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
